import { render, staticRenderFns } from "./CombinationsStepInfo.vue?vue&type=template&id=1b51d2ba&scoped=true"
import script from "./CombinationsStepInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsStepInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsStepInfo.vue?vue&type=style&index=0&id=1b51d2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b51d2ba",
  null
  
)

export default component.exports